import React from "react";
import ResponsiveImage from "./ResponsiveImage";

const Hero = () => {
  return (
    <section className="Media_section_banner">
      <div className="Media_section_banner_img_wrapper">
        <ResponsiveImage
          desktop="/Images/hero-pbs-desktop.webp"
          mobile="/Images/hero-pbs-mobile.webp"
          alt="TWoman in a purple dress preparing a healthy meal with fresh tomatoes, greens and herbs."
          priority
          width={1920}
          height={667}
          desktopAspect="1920 / 667"
          mobileAspect="900 / 1320"
        />
      </div>
      <div className="Media_section_banner_wrapper">
        <div className="page-width">
          <div className="Media_section_banner_block">
            <h1 className="Media_section_banner_title">
              Where Transformation Meets Conversation
            </h1>
            <div className="Media_section_banner_desc desc">
              <p>
                Join host Nafsika Antypas for enlightening conversations about
                the power of plant-based living. Whether you're plant-curious or
                a seasoned vegan, discover how small changes can lead to
                profound impact – for your health, the planet, and beyond.
              </p>
            </div>
            <div className="Media_section_banner_btn_wrap">
              <a
                href="https://www.youtube.com/@NafsikaAntypas/podcasts"
                className="button"
              >
                <img
                  src="https://cdn.shopify.com/s/files/1/0705/9406/8713/files/Vector.png?v=1747043711"
                  width="20"
                  height="20"
                  alt="YouTube Icon"
                />
                START LISTENING
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
